<template funtional>
  <vs-divider color="" position="center" class="mb-2 mt-0 pt-1">
    <div class="flex items-center justify-end text-xg text-dark">
      <p class="font-semibold" :class="{'text-danger': title === 'overdue'}">
        {{title}}{{count > 0 ? ` (${count})` : ''}}
      </p>
    </div>
  </vs-divider>

</template>

<script>
export default {
  props: ['title', 'count'],
}
</script>
